// extracted by mini-css-extract-plugin
export default {"pairInputs":"formBill_pairInputs__oGOl+","icon":"formBill_icon__RbEnE","force":"formBill_force__34lQO","isForce":"formBill_isForce__rkxp+","difference":"formBill_difference__RMXiM"};